/* eslint-disable @typescript-eslint/no-explicit-any */
/** @jsx jsx */ // Kvůli {...props}
import { jsx } from "@emotion/react";
import { FC, Ref } from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch, { SwitchClassKey, SwitchProps } from "@material-ui/core/Switch";
import { Tooltip } from "@material-ui/core";
import { flowioSwitchMuiStyles } from "./styles";
import { noop } from "../../../../globalConsts";
import { OmitBetter } from "../../../../globalTypes";

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

type ControlledOnlyProps = {
  value: boolean;
  defaultValue?: undefined;
  inputRef?: Ref<any>;
};
type UncontrolledOnlyProps = {
  value?: undefined;
  defaultValue: boolean;
  inputRef?: Ref<any>;
};
type RefControlledOnlyProps = {
  value?: undefined;
  defaultValue?: undefined;
  inputRef: Ref<any>;
};

type SharedProps = Omit<
  SwitchProps,
  "value" | "defaultValue" | "checked" | "type" | "defaultChecked" | "onChange"
> & {
  tooltip?: string;
  classes: Styles;
  onChange?(newVal: boolean): void;
  onBlur?(): void;
};

type Props = (
  | ControlledOnlyProps
  | UncontrolledOnlyProps
  | RefControlledOnlyProps
) &
  SharedProps;

const FlowioSwitch: FC<Props> = ({
  classes,
  tooltip,
  onChange = noop,
  onBlur,
  value,
  defaultValue,
  ...rest
}) => {
  const renderSwitch = () => (
    <Switch
      data-cy="flowio-switch-input"
      onBlur={onBlur}
      focusVisibleClassName={classes.focusVisible}
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      onChange={(e) => onChange(e.target.checked)}
      checked={!!value}
      defaultChecked={defaultValue}
      {...rest}
    />
  );

  if (tooltip) return <Tooltip title={tooltip}>{renderSwitch()}</Tooltip>;

  return renderSwitch();
};

export default withStyles(flowioSwitchMuiStyles)(FlowioSwitch);
export type FlowioSwitchProps = OmitBetter<Props, "classes">;
